import React, { Component } from "react";
import { Switch, Route } from "react-router-dom";

//Routes
import {
  HOME,
  CURRENCY,
  CURRENCY_DETAILS,
  STATS,
  EXCHANGE,
  NEWS,
} from "./Components/_Utils/Routes";

//Components
import {
  Navbar,
  Home,
  Currencies,
  CryptoDetails,
  Statistics,
  Exchanges,
  News,
} from "./Components";

export default class RouterComponent extends Component {
  render() {
    return (
      <React.Fragment>
        <Navbar />
        <Switch>
          <Route exact path={HOME} component={Home} />
          <Route exact path={STATS} component={Statistics} />
          <Route exact path={CURRENCY} component={Currencies} />
          <Route exact path={CURRENCY_DETAILS} component={CryptoDetails} />
          <Route exact path={EXCHANGE} component={Exchanges} />
          <Route exact path={NEWS} component={News} />
        </Switch>
      </React.Fragment>
    );
  }
}
